import React from 'react';

const PropertyInfo = ({ propertyData }) => {
  const { areaDetails, floorDetails, availabilityStatus, furnishings, parking, propertyFacing } = propertyData?.aboutProperty || {};
  const { ownershipType } = propertyData?.pricingAndOthers?.OwnershipPriceDetails || {};
  const { buildupArea } = areaDetails || {};
  const { propertyOnFloor, totalFloor } = floorDetails || {};

  const infoItems = [
    buildupArea && { label: "Super Built-Up Area", value: `${buildupArea} sqft` },
    propertyData?.developer && { label: "Developer", value: propertyData.developer },
    propertyData?.project && { label: "Project", value: propertyData.project },
    (totalFloor || propertyOnFloor) && { label: "Floor", value: `${propertyOnFloor} (Out of ${totalFloor} Floors)` },
    propertyData?.transactionType && { label: "Transaction Type", value: propertyData.transactionType },
    availabilityStatus && { label: "Status", value: availabilityStatus },
    propertyFacing && { label: "Facing", value: propertyFacing },
    furnishings?.status && { label: "Furnished Status", value: furnishings.status },
    parking?.coveredParking && { label: "Car Parking", value: parking.coveredParking },
    ownershipType && { label: "Type of Ownership", value: ownershipType }
  ].filter(Boolean).slice(0, 9);

  return (
    <div className="grid grid-cols-3 gap-6 p-4 rounded-lg bg-white">
      {infoItems.map((item, index) => (
        <div key={index}>
          <p className="text-[#606060] font-normal text-[14px]">{item.label}</p>
          <p className="text-[#303030] font-semibold text-sm">{item.value}</p>
        </div>
      ))}
    </div>
  );
};

export default PropertyInfo;
